<template>
  <el-dialog
    class="dialog-wrapper view-diff-modal"
    visible
    show-close
    @close="$emit('dialogClose')"
  >
    <ContentHeader
      slot="title"
      :title="$t('approvalCustomerChanges.viewDiffModal')"
    />
    <el-row
      :gutter="20"
      type="flex"
    >
      <el-col :span="24">
        <div class="table-wrapper">
          <el-table
            class="width-100"
            :data="tableDiffData"
            border
          >
            <el-table-column
              prop="propertyName"
              :label="$t('approvalCustomerChanges.propertyName')"
              :width="200"
            />
            <el-table-column
              prop="original"
              :label="$t('approvalCustomerChanges.original')"
            />
            <el-table-column
              prop="edited"
              :label="$t('approvalCustomerChanges.edited')"
            />
          </el-table>
        </div>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
  import ContentHeader from '@/components/ContentHeader.vue';

  const DIFF_KEYS = [
    'labSampleCode',
    'productName',
    'customerProductName',
    'lot',
    'date',
    'sector',
    'packagesNumber',
    'notes',
    'finalCustomer',
    'sampleDescription',
    'comments',
    'costCenter',
  ];

  export default {
    name: 'ViewDiffModal',
    components: {
      ContentHeader,
    },
    props: {
      diffData: { type: Object, required: true },
    },
    data() {
      return {
        tableDiffData: [],
      };
    },
    created() {
      const { sample, data } = this.diffData;
      const tableRows = Object.keys(sample).filter((k) =>
        DIFF_KEYS.includes(k)
      );
      this.tableDiffData = tableRows.map((key) => ({
        propertyName: this.$t(`filters.${key}`),
        original: sample[key],
        edited: data.sample[key] || '-',
      }));
    },
  };
</script>

<style lang="scss">
  .view-diff-modal {
    .el-dialog {
      width: 60%;
    }
    .table-wrapper .el-table .el-table__row.warning-row {
      background-color: $--color-warning;
    }
  }
</style>
